<template>
  <div id="commonPage_broadcastList" v-show="currThemeObj">
    <div
      class="abs_topArea"
      :style="{
        backgroundImage: `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/${themeHeaderBannerImage}.png')`,
      }"
    >
      <div class="sportsDetail_inforPanel">
        <div class="inforPanel_left">
          <!-- <div class="datePicker">
            <el-date-picker
              v-model="currDate"
              popper-class="broadcastList_datePackagList"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="changeDate"
            ></el-date-picker>
          </div> -->
          <span
            class="btnArrBorder"
            :class="roomArr && roomArr.length === 2 ? 'twoRoom' : ''"
            v-show="roomArr && roomArr.length > 0"
          >
            <span
              class="btnItem"
              :class="[item.act ? 'act' : '', item.isShow ? '' : 'hide']"
              v-for="item in roomArr"
              :key="item.id"
              v-text="item.name"
              @click="clickRoom(item)"
            ></span>
          </span>
        </div>
        <span
          class="addPlayerListBtn"
          v-text="'+创建播出单'"
          @click="addPlayerListClick"
        ></span>
      </div>
      <div class="swiperBox">
        <base_swiper_broadcastList
          v-if="currPlayerItemId && swiper_datas && swiper_datas.length > 0"
          :currItemId="currPlayerItemId"
          :datas="swiper_datas"
          :currGroupOptMap="currGroupOptMap"
          @updateCurrItem="updateCurrSwiperItemHandle"
          @itemOperate="itemOperateHandler"
        ></base_swiper_broadcastList>
      </div>
    </div>
    <div class="broadcastList_area">
      <div class="broadcastList_themeArea">
        <div class="themeArea_box">
          <div class="themeOperation_area">
            <span class="themeType_changeArea">
              <span
                class="themeType_item"
                v-for="item in userArr"
                :key="item.id"
                :class="item.act ? 'act' : ''"
                v-text="item.name"
                @click="changeUser(item)"
              ></span>
            </span>
            <!-- <span
                class="themeType_changeArea"
                v-show="currRoom && currRoom.themeType === 'media'"
              >
                <span
                  class="themeType_item"
                  v-for="item in themeTypeArr"
                  :key="item.id"
                  :class="item.act ? 'act' : ''"
                  v-text="item.name"
                  @click="changeThemeType(item)"
                ></span>
              </span> -->
            <span
              class="themeBtn_area"
              v-if="
                currRoom &&
                themeBtnArr &&
                !(
                  currRoom.themeType === 'all' &&
                  themeList &&
                  themeList.length == 0
                )
              "
            >
              <template v-if="!isBatchChoose">
                <span
                  v-for="item in themeBtnArr[currRoom.themeType]"
                  :key="item.key"
                  v-text="item.name"
                  @click="openDialog(item.key)"
                ></span>
              </template>
              <template v-if="isBatchChoose">
                <span
                  v-for="item in chooseThemeBtnArr[currRoom.themeType]"
                  :key="item.key"
                  v-text="item.name"
                  @click="openDialog(item.key)"
                ></span>
              </template>
            </span>
          </div>
          <themeList_output
            :themeList="themeList"
            :currThemeObj="currThemeObj"
            :chooseStatusClickFunc="chooseStatusClick"
            :isBatchChoose="isBatchChoose"
          >
            <template v-slot:itemClose="themeItem">
              <span
                class="themeContainItem_close el-icon-close"
                @click="
                  removeSingleTheme(
                    themeItem.item,
                    currRoom && currRoom.id ? currRoom.id : ''
                  )
                "
              ></span>
            </template>
            <template v-slot:itemBtnAreaLeft="themeItem">
              <span class="themeContainItem_btnArea left">
                <span class="item_absChoose">
                  <span class="checkbox_item">
                    <svg
                      t="1693726421166"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="21127"
                      width="80%"
                      height="80%"
                    >
                      <path
                        d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                        p-id="21128"
                      ></path>
                    </svg>
                  </span>
                </span>
                <!-- <span
                        class="btnArea_edit"
                        @click="productPicOrVideo(item)"
                        v-show="isMediaBroadcastFlag"
                      >
                        合成
                      </span> -->
                <span class="paddingR10">
                  <LOAD_SUCCESS_BTN
                    :datas="
                      themeItem.item.currPreviewType === 'video'
                        ? themeItem.item.videoPreview_loadSuccessBtnObj
                        : themeItem.item.picPreview_loadSuccessBtnObj
                    "
                    v-show="isMediaBroadcastFlag"
                    @click="productPicOrVideo(themeItem.item)"
                  >
                    合成
                  </LOAD_SUCCESS_BTN>
                </span>
                <span
                  class="btnArea_edit"
                  v-show="themeItem.item.needPicture && isMediaFlag"
                  @click="downDataPicTheme(themeItem.item)"
                >
                  下载
                </span>
                <!-- <span
                        class="btnArea_edit"
                        @click="pushMaterialsItem(themeItem.item)"
                        v-show="isMediaBroadcastFlag"
                      >
                        推送
                      </span> -->

                <!-- 方便测试按钮动画状态的组件 -->
                <!-- <LOAD_SUCCESS_BTN
                        :datas="
                          themeItem.item.currPreviewType === 'video'
                            ? themeItem.item.video_loadSuccessBtnObj
                            : themeItem.item.pic_loadSuccessBtnObj
                        "
                        v-show="isMediaBroadcastFlag"
                        @click="onSubmit(themeItem.item, themeItem.item.currPreviewType)"
                      >
                        推送
                      </LOAD_SUCCESS_BTN> -->

                <LOAD_SUCCESS_BTN
                  :datas="
                    themeItem.item.currPreviewType === 'video'
                      ? themeItem.item.video_loadSuccessBtnObj
                      : themeItem.item.pic_loadSuccessBtnObj
                  "
                  v-show="isMediaBroadcastFlag"
                  @click="pushMaterialsItem(themeItem.item)"
                >
                  推送
                </LOAD_SUCCESS_BTN>
              </span>
            </template>
            <template v-slot:itemBtnAreaRight="themeItem">
              <span class="themeContainItem_btnArea right">
                <span
                  class="btnArea_edit"
                  @click="eidtSingleTheme(themeItem.item)"
                  v-show="
                    !(
                      currRoom &&
                      currRoom.themeType === 'room' &&
                      currUserObj &&
                      currUserObj.id !== 'defaultUser'
                    )
                  "
                >
                  编辑标题
                </span>
                <span
                  class="btnArea_edit"
                  v-show="
                    currUserObj &&
                    currUserObj.id !== 'defaultUser' &&
                    currRoom &&
                    currRoom.themeType === 'room' &&
                    themeItem.item.needPicture
                  "
                  v-text="'下载图片'"
                  @click="downDataPicTheme(themeItem.item)"
                ></span>
                <span
                  class="btnArea_edit"
                  v-show="
                    currUserObj &&
                    !['defaultUser', 'daYangUser'].includes(currUserObj.id) &&
                    currRoom &&
                    currRoom.themeType === 'room'
                  "
                  v-text="'下载数据'"
                  @click="downDataSingleTheme(themeItem.item)"
                ></span>
                <span
                  class="btnArea_edit"
                  v-show="
                    currUserObj &&
                    ['daYangUser'].includes(currUserObj.id) &&
                    currRoom &&
                    currRoom.themeType === 'room'
                  "
                  v-text="'推送数据'"
                  @click="
                    clickDaYangPushDataThemeItem(themeItem.item, currUserObj)
                  "
                ></span>
                <span class="btnGroup" v-show="isMediaBroadcastFlag">
                  <span
                    class="btnItem"
                    :class="
                      themeItem.item.currPreviewType === 'pic' ? 'act' : ''
                    "
                    @click="themeChangeType(themeItem.item, 'pic')"
                  >
                    图片
                  </span>
                  <span
                    class="btnItem"
                    :class="
                      themeItem.item.currPreviewType === 'video' ? 'act' : ''
                    "
                    @click="themeChangeType(themeItem.item, 'video')"
                  >
                    视频
                  </span>
                </span>
              </span>
            </template>
          </themeList_output>
          <div
            class="themeList_page"
            v-show="themeList && themeList.length > 0"
          >
            <el-pagination
              popper-class="mixtmt_pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
            ></el-pagination>
          </div>
          <template>
            <NOT_DATA
              :className="'relativePtb60'"
              v-show="themeList && themeList.length == 0"
            />
          </template>
        </div>
      </div>
    </div>

    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>

    <!-- 常规提示层 -->
    <el-dialog
      :title="
        [
          'eidtThemeItemName',
          'setOption',
          'broacdcast_eidtPlayerItem',
          'broacdcast_addPlayerItem',
        ].includes(dialogType)
          ? dialogText
          : '提示'
      "
      custom-class="mixtmt_dialog"
      :visible.sync="isDialogFlag"
      width="40vw"
      top="0"
      center
    >
      <template v-if="dialogType === 'setOption'">
        <div :class="dialogType">
          <div
            class="optionGroup"
            v-for="group in optionList"
            :key="group.type"
          >
            <span class="optionGroup_title">
              <span class="title_icon" :class="group.type"></span>
              <span
                class="name"
                v-text="
                  setOptionGruopTitleNameArr[
                    setOptionGruopTitleKeyArr.indexOf(group.type)
                  ]
                "
              ></span>
            </span>
            <span
              class="optionGroup_list"
              v-for="item in group.twos"
              :key="item.typeTwo"
            >
              <span class="optionItem">
                <span
                  class="optionItem_title"
                  v-text="`${item.typeTwoName}：`"
                ></span>
                <el-checkbox-group v-model="item.checkList">
                  <el-checkbox
                    v-for="ceil in item.threes"
                    :key="ceil.typeThree"
                    :label="ceil.typeThreeName"
                  ></el-checkbox>
                </el-checkbox-group>
              </span>
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <span
          v-show="
            ![
              'eidtThemeItemName',
              'broacdcast_addPlayerItem',
              'broacdcast_eidtPlayerItem',
            ].includes(dialogType)
          "
        >
          <span class="dialogText" v-text="dialogText"></span>
        </span>
        <span
          v-show="
            [
              'eidtThemeItemName',
              'broacdcast_addPlayerItem',
              'broacdcast_eidtPlayerItem',
            ].includes(dialogType)
          "
          class="row_input"
        >
          <span class="row_title">标 题</span>
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 2 }"
            placeholder="请输入内容"
            v-model="editThemeTitle"
          ></el-input>
        </span>
      </template>
      <span slot="footer" class="dialog-footer">
        <span @click="cancelDialog">取 消</span>
        <span @click="clickThemeBtnArea(dialogType)" class="ok">确 定</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  https_package_getPackageRoom,
  https_broadcast_postPlayerItemToThemeList,
  https_broadcast_postBroadcasts,
  https_broadcast_postCreateBroadcast,
  https_broadcast_postRemoveBroadcast,
  https_broadcast_postEditBroadcast,
  https_broadcast_postBroadcastShareState,
  https_broadcast_postSaveBroadcastShareState,
} from '@api/platfrom_base_api'

import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import themeList_output_data_mixin from '@mixins/themeList_output_data'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
import base_swiper_broadcastList from '@components/base/swiper_broadcastList.vue'
const envPro = require('@src/envPro/index')

export default {
  name: 'commonPage_broadcastList',
  mixins: [
    cup_base_data_mixin,
    themeList_output_data_mixin,
    customizeProMixins_data_mixin,
  ],
  components: {
    NOT_DATA,
    base_swiper_broadcastList,
  },
  props: {
    themeHeaderBannerImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      curValArr: [],
      containerCascaderMeun_isOpenFlag: false,
      selectTab_pageJumpParams: [],
      sportsAndEventList: [],
      eventChildren: null,
      matchDateArr: null, //这个赛季所有比赛
      roomArr: null,
      currRoom: null,
      currUserObj: null,
      userArr_base: [
        {
          name: '数据分析工作台',
          id: 'defaultUser',
          act: false,
        },
      ],
      userArr: [
        // {
        //   name: '数据分析工作台',
        //   id: 'defaultUser',
        //   act: true,
        // },
        // {
        //   name: '在线包装工作台',
        //   id: 'packageUser',
        //   act: false,
        // },
        // {
        //   name: '在线包装工作台',
        //   id: 'daYangUser',
        //   act: false,
        // },
        // {
        //   name: '安全岛工作台',
        //   id: 'safetyUser',
        //   act: false,
        // },
      ],
      //   themeTypeArr: [
      //     {
      //       name: '网页',
      //       id: 'web',
      //       act: false,
      //     },
      //     {
      //       name: '广播级',
      //       id: 'broadcast',
      //       act: true,
      //     },
      //   ],
      currThemeType: null,
      // themeBtnArr: {
      //   all: [],
      //   media: [],
      //   room: [],
      // },
      themeBtnArr: null,
      chooseThemeBtnArr: {
        room: [
          {
            name: '确定',
            key: 'batchChoose_roomRemoveOk',
          },
          {
            name: '取消',
            key: 'batchChoose_removeCancel',
          },
        ],
      },
      comThemeBtnArr: {
        room: [
          {
            name: '刷新',
            key: 'refreshPage',
          },
          {
            name: '批量删除',
            key: 'roomRemove',
          },
        ],
      },
      adminThemeBtnArr: {
        room: [
          {
            name: '下载全部数据',
            key: 'downAllData',
          },
          {
            name: '生成播单',
            key: 'broacdcast_produceList',
          },
        ],
      },
      daYangThemeBtnArr: {
        room: [
          {
            name: '推送播单数据',
            key: 'broacdcast_pushAllDaYange',
            pushPrefix: '',
          },
        ],
      },
      themeParams: null, //公共播单接口参数对象
      roomThemeParams: null, //某个演播室接口参数对象
      isBatchChoose: false, //控制所有主题上是否显示多选按钮

      eventGourpNum: 5, //每组里面5个元素最多
      currDate: '',
      roomArrAllWidthVw: 0,
      swiper_datas: [],
      currPlayerItemId: '',

      isDialogFlag: false,
      dialogText: '',
      dialogType: '',
      currItemTheme: null,
      editThemeTitle: '',
      groupThemeOptMap: null,
      userRoleKey_safetyIsland: 'safetyIsland', //显示 安全岛工作台 btn
      userRoleKey_onlinePackage: 'onlinePackage', //显示 在线包工作台 btn
    }
  },
  //   watch: {
  //     currSportsDetail: {
  //       handler(newVal, oldVal) {
  //         // console.debug('重新刷新数据1:', newVal, oldVal)
  //         if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
  //           this.autoLoadThemeList()
  //         }
  //       },
  //       //   immediate: true,
  //       deep: true,
  //     },
  //   },
  created() {
    // 根据开发环境 判断
    // let envStatus = envPro.getEnvStatus()
    // if (envStatus !== 'build') {
    //   // 央视需要 安全岛
    //   this.userArr.push({
    //     name: '安全岛工作台',
    //     id: 'safetyUser',
    //     act: false,
    //   })
    // }
    this.getUserRoleList()
    // if (this.mixtmt_userRoleKeyList.includes(this.userRoleKey_onlinePackage)) {
    //   // 是否显示 在线包
    //   this.userArr.push({
    //     name: '在线包装工作台',
    //     id: 'packageUser',
    //     act: false,
    //   })
    // }
    // if (this.mixtmt_userRoleKeyList.includes(this.userRoleKey_safetyIsland)) {
    //   // 公司和央视需要 安全岛
    //   this.userArr.push({
    //     name: '安全岛工作台',
    //     id: 'safetyUser',
    //     act: false,
    //   })
    // }

    this.currUserObj = this.userArr_base[0]
    if (this.currGroup) {
      console.debug('init')
      this.init()
    }
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)

      await this.getGroupOptMap()
      if (!this.roomArr) {
        await this.getPackageRoom()
      }
      console.debug('currGroup:', this.currGroup, this.roomArr)
      await this.clickRoom(this.currRoom)

      //   window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    // autoInit() {
    //   setTimeout(() => {
    //     if (this.currGroup && this.currGroup.groupId) {
    //       this.init()
    //     } else {
    //       this.autoInit()
    //     }
    //   }, 50)
    // },
    async updateCurrSwiperItemHandle(item) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.currPlayerItemId = item.id
      this.swiper_datas = this.makeSwiperDatas(
        this.swiper_datas_orgin,
        this.eventGourpNum,
        this.currPlayerItemId
      )
      await this.loadRoomThemeList()
      console.debug('加载播出单数据')
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    itemOperateHandler(data) {
      if (data.type === 'removeItem') {
        this.openDialog('broacdcast_removeItem', data.item)
      } else if (data.type === 'eidtSingleItem') {
        this.openDialog('broacdcast_eidtPlayerItem', data.item)
      } else if (data.type === 'shareItem') {
        console.debug('broacdcast_shareItem')
        // 访问接口，将新的配置保存到服务器；然后标记最新的对勾
        let currGroupOptMap = {
          date: this.currDate,
          roomId: this.currRoom.id,
          playerItemId: data.item.id,
        }
        this.saveGroupOptMap(currGroupOptMap)
      }
    },
    async removeSwiperItemHandle(item) {
      // 访问删除单个播出单接口
      await this.postRemoveBroadcast(item.id)
      if (item.id === this.currGroupOptMap.playerItemId) {
        // 如果删除的播出单是配置里面选中的，则默认选中当前room下第一个播出单；因为每个room下最少有5个播单是不能删除的
        this.currGroupOptMap.playerItemId = this.swiper_datas[0].dayArr[0].id

        // 将最新的保存到服务器上面
        await this.saveGroupOptMap(this.currGroupOptMap)
      }
      if (this.currPlayerItemId === item.id) {
        // 只有删除的是当前选中的播出单，才需要重置 this.currPlayerItemId ; 否则不用管
        this.currPlayerItemId = ''
      }
      await this.getPlayerListDatas()
    },
    addPlayerListClick() {
      this.openDialog('broacdcast_addPlayerItem')
    },
    makeSwiperDatas(arr, groupNum, currId, shareId) {
      let groupList = []
      let itemArr = []
      arr.forEach((item) => {
        if (currId) {
          if (currId === item.id) {
            item.act = true
          } else {
            item.act = false
          }
        }
        if (shareId && shareId === item.id) {
          item.isMakeShare = true
        } else {
          item.isMakeShare = false
        }
        itemArr.push(item)
        if (itemArr.length === groupNum) {
          groupList.push({ dayArr: itemArr })
          itemArr = []
        }
      })
      if (itemArr.length > 0) {
        groupList.push({ dayArr: itemArr })
      }

      return groupList
    },
    isChinaString(str) {
      let flag = false
      var pattern = new RegExp('[\u4E00-\u9FA5]+')
      if (pattern.test(str)) {
        // alert('该字符串是中文')
        flag = true
      }
      return flag
    },
    async clickRoom(item) {
      this.roomArr.forEach((tabItem) => {
        if (item.id === tabItem.id) {
          tabItem.act = true
          this.currRoom = tabItem
          this.currPlayerItemId = ''
        } else {
          tabItem.act = false
        }
      })
      await this.getPlayerListDatas()
      const userArr = JSON.parse(JSON.stringify(this.userArr_base))
      if (item.type === 4) {
        // 大洋演播室
        userArr.push({
          name: '在线包装工作台',
          id: 'daYangUser',
          act: false,
          pushPrefix: item.pushPrefix,
        })
      } else {
        if (
          this.mixtmt_userRoleKeyList.includes(this.userRoleKey_onlinePackage)
        ) {
          // 是否显示 在线包
          userArr.push({
            name: '在线包装工作台',
            id: 'packageUser',
            act: false,
          })
        }
        if (
          this.mixtmt_userRoleKeyList.includes(this.userRoleKey_safetyIsland)
        ) {
          userArr.push({
            name: '安全岛工作台',
            id: 'safetyUser',
            act: false,
          })
        }
      }
      let actUserIndex = 0
      // userArr.forEach((userItem, userIndex) => {
      //   if (userItem.id === this.currUserObj.id) {
      //     actUserIndex = userIndex
      //   }
      // })
      userArr[actUserIndex].act = true
      this.currUserObj = userArr[actUserIndex]
      this.userArr = userArr
      this.changeUserTabToBtns()
    },
    // changeDate(val) {
    //   console.debug(val, this.currDate)
    //   this.currPlayerItemId = ''
    //   this.getPlayerListDatas()
    // },
    openMeun(flag) {
      this.containerCascaderMeun_isOpenFlag = !flag
    },
    clickIsOpenMeunHandler(data) {
      console.debug('clickIsOpenMeunHandler:', data)
      this.containerCascaderMeun_isOpenFlag = data
    },
    changeUser(item) {
      this.currUserObj = item
      this.userArr.forEach((user) => {
        if (user.id === item.id) {
          user.act = true
        } else {
          user.act = false
        }
      })
      this.changeUserTabToBtns()
    },
    changeUserTabToBtns() {
      // 当btn改变后要更新对应【按钮】
      if (this.currUserObj.id === 'defaultUser') {
        // 切换成播出单普通用户
        this.themeBtnArr = this.comThemeBtnArr
      } else if (this.currUserObj.id === 'daYangUser') {
        // 切换成大洋用户
        this.themeBtnArr = this.daYangThemeBtnArr
      } else {
        // 切换成播出单管理员
        this.themeBtnArr = this.adminThemeBtnArr
      }
    },
    chooseStatusClick(themeItem) {
      console.debug('chooseStatusClick:', this.isBatchChoose, themeItem)
      if (!this.isBatchChoose) {
        return
      }
      if (themeItem.isChooseAct) {
        const saveChooseThemeItemArr = []
        this.saveChooseThemeItemArr.forEach((id) => {
          if (id !== themeItem.dataItemId) {
            saveChooseThemeItemArr.push(id)
          }
        })
        this.saveChooseThemeItemArr = saveChooseThemeItemArr
      } else {
        this.saveChooseThemeItemArr.push(themeItem.dataItemId)
      }
      themeItem.isChooseAct = !themeItem.isChooseAct
    },
    async getGroupOptMap() {
      // 获取存储服务器 组的播出单配置文件
      const params = {
        groupId: this.currGroup.groupId,
        competitionId: this.currCid,
        // seasonId: this.currSid,
      }
      await https_broadcast_postBroadcastShareState(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.currGroupOptMap = {
              date: res.data.date,
              roomId: res.data.packageId,
              playerItemId: res.data.broadcastId,
            }
            this.currDate = this.currGroupOptMap.date
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async saveGroupOptMap(optMap) {
      // 将最新的 组的播出单配置文件 保存到服务器
      const params = {
        groupId: this.currGroup.groupId,
        packageId: this.currRoom.id,
        competitionId: this.currCid,
        // seasonId: this.currSid,
        // date: optMap.date,
        broadcastId: optMap.playerItemId,
      }
      await https_broadcast_postSaveBroadcastShareState(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            console.debug(this.currGroupOptMap, optMap)
            this.currGroupOptMap = optMap
            this.$forceUpdate()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async autoLoadThemeList() {
      // 主题更换就要重置数组，因为重新刷新回来的时候数据里面就是最新状态的
      // if (
      //   this.savePreviewPicArr.length > 0 ||
      //   this.savePreviewVideoArr.length > 0 ||
      //   this.savePushMaterialsPicArr.length > 0 ||
      //   this.savePushMaterialsVideoArr > 0
      // ) {
      //   // 取消接口访问
      //   this.axiosCancelSource.cancel('取消接口访问')
      // }
      // this.savePreviewPicArr = []
      // this.savePreviewVideoArr = []
      // this.savePushMaterialsPicArr = []
      // this.savePushMaterialsVideoArr = []
      // console.debug('重置数组')
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initScroll()
      if (this.scrollAreaDom.scrollTop > 200) {
        this.goBackTop() //返回顶部
      }
      await this.getPlayerListDatas() // 由于对单个播单的增删改等操作，不止需要刷新单个播单数据，也需要刷新播单列表中的状态
      await this.loadRoomThemeList()
    },
    async loadRoomThemeList() {
      // 单个演播室
      console.debug('themeBtnArr:', this.currRoom, this.themeBtnArr)
      this.roomThemeParams = {
        packageId: this.currRoom.id,
        broadcastId: this.currPlayerItemId,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      await this.getRoomPackageItemInfos(this.roomThemeParams)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getPackageRoom() {
      let params = {
        groupId: this.currGroup.groupId,
      }
      await https_package_getPackageRoom(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let roomArrAllWidthVw = 0
            let strNumVw = 1.25
            let notStrNumVw = 0.8
            let currGroupOptMap_roomIndex = 0
            this.roomArr = res.data.map((val, index) => {
              if (val.id === this.currGroupOptMap.roomId) {
                currGroupOptMap_roomIndex = index
              }
              console.debug('val:', val)
              if (val.type === 4) {
                // 推送时大洋内网地址
                this.daYangThemeBtnArr.room[0].pushPrefix = val.pushPrefix
              }
              val.themeType = 'room'
              val.isShow = true
              val.act = false
              let nameStringArr = val.name.split('')
              val.widthVw = 0
              nameStringArr.forEach((str) => {
                if (this.isChinaString(str)) {
                  val.widthVw += strNumVw
                } else {
                  val.widthVw += notStrNumVw
                }
              })
              roomArrAllWidthVw += val.widthVw
              return val
            })

            this.roomArrAllWidthVw = roomArrAllWidthVw

            this.currRoom = this.roomArr[currGroupOptMap_roomIndex]
            console.debug('this.currRoom:', this.roomArr, this.currUserObj)
            if (this.currUserObj.id === 'defaultUser') {
              this.themeBtnArr = this.comThemeBtnArr
            } else {
              // 切换成播出单管理员
              this.themeBtnArr = this.adminThemeBtnArr
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerListDatas() {
      let params = {
        groupId: this.currGroup.groupId,
        packageId: this.currRoom.id,
        competitionId: this.currCid,
        // seasonId: this.currSid,
        // date: this.currDate,
      }
      let isLoadThemeList = false
      if (!this.currPlayerItemId) {
        // 获取 播出单里面的主题数据
        isLoadThemeList = true
      }
      await https_broadcast_postBroadcasts(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.swiper_datas_orgin = []
            this.swiper_datas_orgin = res.data.map((item) => {
              let obj = {
                id: item.broadcastId,
                name: item.broadcastName,
                themeNum: item.subjectNum,
                isAct: false, //播出单被选中
                isRemove: item.broadcastType, //是否可以删除; 0:默认不可以删；1:新增可以删
              }
              if (
                this.currGroupOptMap.playerItemId === obj.id &&
                !this.currPlayerItemId
              ) {
                // 第一次初始化时，如果有配置中选中的播出单，则自动切到该播出单上面
                this.currPlayerItemId = obj.id
              }
              return obj
            })
            if (!this.currPlayerItemId) {
              this.currPlayerItemId = res.data[0].broadcastId
            }
            this.swiper_datas = this.makeSwiperDatas(
              this.swiper_datas_orgin,
              this.eventGourpNum,
              this.currPlayerItemId
            )
            // console.debug('this.swiper_datas:', this.swiper_datas)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      if (isLoadThemeList) {
        // this.currPlayerItemId 被赋新的值，所以要重新加载新的数据
        await this.autoLoadThemeList()
      }
    },
    async getRoomPackageItemInfos(query) {
      //获取单个演播室主题
      await https_broadcast_postPlayerItemToThemeList(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.themeList = res.data
              ? this.allThemeRenderHandler(res.data.list)
              : []
            console.debug('themeList:', this.themeList)
            this.total = res.data.total
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async postCreateBroadcast(name) {
      // 创建播出单
      let params = {
        groupId: this.currGroup.groupId,
        packageId: this.currRoom.id,
        competitionId: this.currCid,
        // seasonId: this.currSid,
        // date: this.currDate,
        broadcastName: name,
      }
      await https_broadcast_postCreateBroadcast(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            // this.currPlayerItemId = res.data
            this.currPlayerItemId = null
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      await this.getPlayerListDatas()
    },
    async postEditBroadcast(name, broadcastId) {
      // 修改播出单
      let params = {
        groupId: this.currGroup.groupId,
        packageId: this.currRoom.id,
        competitionId: this.currCid,
        // seasonId: this.currSid,
        // date: this.currDate,
        broadcastName: name,
        broadcastId,
      }
      await https_broadcast_postEditBroadcast(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      await this.getPlayerListDatas()
    },
    async postRemoveBroadcast(id) {
      // 删除播出单
      let params = {
        broadcastId: id,
      }
      await https_broadcast_postRemoveBroadcast(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      await this.getPlayerListDatas()
    },
  },
}
</script>

<style lang="scss" scoped>
#commonPage_broadcastList {
  padding-top: 12.36vw;
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 15.27vw;
    color: var(--mixtmt_whiteColor);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .sportsDetail_inforPanel {
      height: 5.55vw;
      width: 100%;
      padding-top: 1.38vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .inforPanel_left {
        width: calc(100% - 9.74vw);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .datePicker {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          height: calc(2.893vw + 1px + 1px);
          width: 12vw;
          margin-right: 1.38vw;
        }
        .btnArrBorder {
          /* width: calc(14.4vw + 1px + 1px + 0.534vw); */
          width: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          border: 1px solid var(--mixtmt_whiteColor);
          padding: 0.267vw;
          border-radius: 0.556vw;
          margin-right: 1.38vw;
          /* height: 2.78vw; */
          transition: width 0.3s linear;
          &.twoRoom {
            .btnItem {
              &:last-child {
                margin: 0 calc(1px + 1px);
              }
            }
          }
          .btnItem {
            /* flex: 1; */
            /* width: 4.8vw; */
            width: auto;
            padding: 0.416vw;
            text-align: center;
            font-size: 1.11vw;
            line-height: 1.527vw;
            color: var(--mixtmt_whiteColor);
            white-space: nowrap;
            overflow: hidden;
            margin: 0 calc(1px + 1px);
            &.act {
              background-color: var(--mixtmt_whiteColor);
              border-radius: 0.416vw;
              color: var(--mixtmt_mainColor);
            }
            &.hide {
              display: none;
            }
            &:first-child,
            &:last-child {
              margin: 0;
            }
          }
        }
      }
      .addPlayerListBtn {
        width: 9.74vw;
        line-height: calc(2.893vw + 1px + 1px);
        font-size: 1.11vw;
        text-align: center;
        background-color: var(--mixtmt_whiteColor);
        color: var(--mixtmt_broadcast_swiper_actBg);
        border-radius: 0.556vw;
      }
      .detailInfor_left {
        position: relative;
        width: calc(100% - 12.48vw - 1.38vw - 1px - 1px - 0.534vw);
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 1.38vw;
        transition: width 0.3s linear;
        &.singleItem {
          width: calc(100% - 4.16vw - 1.38vw - 1px - 1px - 0.534vw);
        }
        &::before {
          position: absolute;
          left: 0;
          top: 50%;
          z-index: 2;
          transform: translateY(-50%);
          content: '\20';
          width: 1px;
          height: 2.77vw;
          background-color: var(--mixtmt_whiteColor);
        }
        .detailInfor_left_colum1 {
          width: 2.5vw;
          height: 2.5vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          border-radius: 50%;
          border: 0.208vw solid var(--mixtmt_whiteColor);
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .detailInfor_left_colum2 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: calc(100% - 2.5vw);
          padding-left: 0.694vw;
          color: var(--mixtmt_whiteColor);
          font-weight: bold;
          .nameItem {
            padding: 0 0.374vw;
            font-size: 1.38vw;
            width: auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .symbol {
            font-size: 2.08vw;
          }
          .select_icon {
            font-size: 1.11vw;
            transition: transform 0.3s linear;
            transform: rotate(0);
            &.open {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
    .swiperBox {
      padding-top: 0.694vw;
    }
  }
  .broadcastList_area {
    width: 100%;
    padding: 2.083vw 0 2.778vw;

    .broadcastList_themeArea {
      /* width: calc(100% - 20.83vw); */
      width: 100%;
      /* padding-left: 1.388vw; */
      .themeArea_box {
        width: 100%;
        padding: 1.388vw;
        /* border: 1px solid var(--mixtmt_greyColor7); */
        border-radius: 0.556vw;
        .themeOperation_area {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.5vw;
          .themeType_changeArea {
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
            border-radius: 1.25vw;
            .themeType_item {
              width: 8.62vw;
              line-height: calc(2.5vw - 2px);
              text-align: center;
              color: var(--mixtmt_btn_tabMeun_actColor);
              font-size: 0.972vw;
              border-left: 1px solid;
              border-right: 1px solid;
              &.act {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
                &:first-child {
                  border-radius: 1.25vw 0 0 1.25vw;
                }
                &:last-child {
                  border-radius: 0 1.25vw 1.25vw 0;
                }
              }
              &:first-child,
              &:last-child {
                border: 0;
              }
            }
          }
          .themeBtn_area {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            align-items: center;
            span {
              display: inline-block;
              margin-left: 0.972vw;
              line-height: calc(2.5vw - 2px);
              font-size: 1.11vw;
              padding: 0 0.972vw;
              border: 1px solid var(--mixtmt_greyColor7);
              color: var(--mixtmt_greyColor2);
              border-radius: 2px;
              &:first-child {
                margin-left: 0;
              }
            }
          }
        }
      }
      .themeList_page {
        text-align: right;
      }
    }

    .cardTheme {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-direction: column;
      .themeItem_title {
        margin-bottom: 1.388vw;
        width: 100%;
        height: 2.5vw;
        background-image: var(--mixtmt_themeItem_title_bg0);
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        color: var(--mixtmt_whiteColor);
        font-size: 0.972vw;
        text-align: center;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
      }
      .card_item {
        width: 60%;
        height: calc(21.54vw - 1.388vw);
        .cardItem_topBg {
          display: block;
          width: 100%;
          height: 0.42vw;
          background-color: var(--mixtmt_mainColor3);
        }
        .cardItem_main {
          position: relative;
          display: block;
          border: 1px solid var(--mixtmt_mainColor3);
          border-top: none;
          height: auto;
          color: var(--mixtmt_greyColor3);
          .cardItem_main_title {
            display: block;
            width: 100%;
            height: 4.166vw;
            line-height: 4.166vw;
            font-size: 1.25vw;
            text-align: center;
          }
          .theme_publishBtn {
            position: absolute;
            top: 1vw;
            right: 0;
            z-index: 10;
            width: 2.778vw;
            text-align: center;
            font-size: 1.11vw;
            line-height: 2.166vw;
            color: var(--mixtmt_blackColor);
          }
          .cardItem_row {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 2.083vw;
            width: 100%;
            height: calc(3.33vw + 1px);
            border-top: 1px solid var(--mixtmt_greyColor7);
            .cardItem_row_image {
              width: 2.083vw;
              height: 2.083vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .cardItem_row_text {
              width: calc(100% - 2.083vw);
              padding-left: 0.833vw;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 0.972vw;
            }
            &.overviewTeamData,
            &.overviewPlayerData {
              padding: 0 0.694vw;
              .rankNo {
                width: 1.388vw;
                font-size: 0.972vw;
                text-align: center;
              }
              .cardItem_row_name {
                width: calc(100% - 1.388vw - 2.083vw - 3.472vw);
                padding-left: 0.833vw;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.972vw;
              }
              .cardItem_row_val {
                width: 3.472vw;
                text-align: right;
                padding-left: 0.833vw;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.972vw;
              }
            }
            &.overviewTeamData {
              .cardItem_row_name {
                width: calc(100% - 1.388vw - 2.083vw - 7.472vw);
              }
              .cardItem_row_val {
                width: 7.472vw;
              }
            }
          }
        }
      }
    }
  }
  .changeUserBtn {
    position: fixed;
    right: 1.388vw;
    bottom: 1.388vw;
    z-index: 1100;
    width: 2.778vw;
    height: 2.778vw;
    span {
      display: block;
      font-size: 1.338vw;
      line-height: 2.778vw;
      text-align: center;
      background-color: var(--mixtmt_whiteColor);
      border: 1px solid var(--mixtmt_greyColor7);
      color: var(--mixtmt_greyColor6);
      border-radius: 50%;
    }
    &.act {
      span {
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
        border: 1px solid var(--mixtmt_subColor1_1);
      }
    }
  }
}
.mixtmt_pc #commonPage_broadcastList,
.mixtmt_ipad #commonPage_broadcastList {
  padding: 12.36vw 0 0;
}
.mixtmt_pc #commonPage_broadcastList {
  .abs_topArea {
    .sportsDetail_inforPanel {
      height: 5.55vw;
      width: 100%;
      padding-top: 1.38vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .btnArrBorder {
        .btnItem {
          &:hover {
            cursor: pointer;
            background-color: var(--mixtmt_whiteColor);
            border-radius: 0.416vw;
            color: var(--mixtmt_mainColor);
          }
        }
      }
      .addPlayerListBtn {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_broadcast_swiper_actBg);
          color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
  .broadcastList_area {
    .broadcastList_themeArea {
      .themeArea_box {
        .themeOperation_area {
          .themeType_changeArea {
            .themeType_item {
              cursor: pointer;
              &:hover {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
                &:first-child {
                  border-radius: 1.25vw 0 0 1.25vw;
                }
                &:last-child {
                  border-radius: 0 1.25vw 1.25vw 0;
                }
              }
            }
          }
          .themeBtn_area {
            span {
              cursor: pointer;
              &:hover {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
    }
  }
  .changeUserBtn {
    &:hover {
      cursor: pointer;
      span {
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
      }
    }
    &.act:hover {
      span {
        color: var(--mixtmt_subColor1_1);
        background-color: var(--mixtmt_whiteColor);
      }
    }
  }
}
</style>
<style lang="scss">
#commonPage_broadcastList {
  .matchArea_date {
    .el-carousel__container {
      height: calc(4.16vw - 2px);
    }
    .el-carousel__arrow {
      cursor: default;
      height: 2.083vw;
      width: 2.083vw;
      background-color: transparent;
      i {
        cursor: default;
        color: var(--mixtmt_greyColor3);
      }
    }
  }
  .themeList_page {
    .el-pager li {
      padding: 0 0.53333vw;
      background: var(--mixtmt_whiteColor);
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      box-sizing: border-box;
    }
    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
      display: inline-block;
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      vertical-align: top;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .el-pagination .el-select .el-input {
      width: 6.944vw;
      margin: 0 0.66667vw;
    }
    .el-pagination .el-select .el-input .el-input__inner {
      padding-right: 1.11vw;
      border-radius: 0.4vw;
      height: 2.22vw;
      line-height: 2.22vw;
      font-size: 0.972vw;
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 2.22vw;
      font-size: 0.972vw;
      line-height: 2.22vw;
    }
    .el-pagination__editor.el-input {
      width: 4.16vw;
    }
    .el-pagination__jump {
      margin-left: 0.972vw;
    }
    .el-pagination__sizes {
      margin: 0;
    }
    .el-pager li.active,
    .el-pager li:hover,
    .el-pagination button:hover,
    .el-pagination__sizes .el-input .el-input__inner:hover {
      color: var(--mixtmt_subColor1_1);
    }
    .el-pagination__sizes .el-input .el-input__inner:hover,
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: var(--mixtmt_subColor1_1);
    }
  }
  .el-dialog__wrapper {
    width: 100%;
    z-index: 1610 !important;
    .mixtmt_dialog {
      border-radius: 1.042vw;
      transform: translateY(-50%);
      top: 50%;
      .el-dialog__header {
        padding: 2.083vw 2.778vw 1.043vw 2.778vw;
        .el-dialog__title {
          line-height: 1.8vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
      }
      .el-dialog__body {
        padding: 1.043vw 2.778vw;
        .dialogText {
          line-height: 1.388vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
        .row_input {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          .row_title {
            padding-right: 0.694vw;
            width: 6.94vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor3);
            text-align: center;
          }
          .el-input {
            color: var(--mixtmt_greyColor2);
            input {
              height: 2.778vw;
              line-height: calc(2.778vw - 2px);
              font-size: 0.972vw;
              background-color: var(--mixtmt_greyColor8);
              padding: 0 4vw 0 1.042vw;
            }
            .el-input__count .el-input__count-inner {
              background-color: var(--mixtmt_greyColor8);
            }
          }
        }
        .setOption {
          max-height: 20.83vw;
          overflow-y: auto;
          .optionGroup {
            width: 100%;
            height: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            .optionGroup_title {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;

              color: var(--mixtmt_greyColor3);
              .title_icon {
                width: 1.388vw;
                height: 1.388vw;
                overflow: hidden;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center;
                background-color: var(--mixtmt_greyColor8);
                /* &.video {
                    background-image: var();
                  } */
              }
              .name {
                padding-left: 0.694vw;
                font-size: 1.11vw;
                line-height: 1.388vw;
              }
            }
            .optionGroup_list {
              padding-top: 2.083vw;
              height: auto;
              .optionItem {
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: center;
                padding: 0 0.694vw 0 2.083vw;
                .optionItem_title {
                  width: 8.333vw;
                  font-size: 1.11vw;
                }
                .el-checkbox {
                  font-size: 1.11vw;
                  margin-right: 2.083vw;
                }
              }
              &:last-child {
                .optionItem {
                  padding-bottom: 2.788vw;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        padding: 2.083vw 2.778vw;
        .dialog-footer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            width: 10.416vw;
            height: 2.778vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.778vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_mainColor3);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-left: 1.388vw;
            }
          }
        }
      }
    }
  }
  .el-drawer__wrapper {
    z-index: 1650 !important;
  }
  .mixtmt_broadcast_derawer {
    header {
      display: none;
    }
  }
}

.mixtmt_pc #commonPage_broadcastList {
  .abs_topArea {
    .sportsDetail_inforPanel {
      .detailInfor_left {
        &:hover,
        &.act {
          cursor: pointer;
          .detailInfor_left_colum1 {
            border: 0.208vw solid var(--mixtmt_subColor4_1);
          }
          .detailInfor_left_colum2 {
            color: var(--mixtmt_subColor4_1);
          }
        }
      }
    }
  }
  .matchArea_date {
    .el-carousel__arrow {
      cursor: pointer;
      i {
        cursor: pointer;
      }
      &:hover {
        i {
          opacity: 0.6;
        }
      }
    }
  }
  .el-dialog__wrapper {
    .mixtmt_dialog {
      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: var(--mixtmt_mainColor);
      }
      .el-dialog__footer {
        .dialog-footer {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              border-color: var(--mixtmt_mainColor6);
            }
          }
        }
      }
    }
  }
  .dateMatch_row {
    .el_icon_btn,
    .matchText {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_subColor1_1);
      }
    }
    .matchText {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.mixtmt_pagination {
  .el-select-dropdown__item {
    font-size: 0.972vw;
    padding: 0 1.388vw;
    height: 2.778vw;
    line-height: 2.778vw;
    &.selected {
      color: var(--mixtmt_mainColor);
    }
    &.hover {
      background-color: var(--mixtmt_greyColor9);
    }
  }
}
</style>
